import bodymovin from "lottie-web";

const lottyAnim = (elem, autoplay) => {
	elem.querySelector('.anim-fallback-image') && elem.querySelector('.anim-fallback-image').remove();
	return bodymovin.loadAnimation({
		wrapper: elem,
		animType: "svg",
		autoplay,
		loop: elem.getAttribute("data-anim-loop") === "true",
		rendererSettings: {
			preserveAspectRatio: "none",
			filterSize: {
				width: '250%',
				height: '250%',
				x: '-50%',
				y: '-50%',
			},
		},
		path: elem.getAttribute("data-path"),
		assetsPath: elem.getAttribute("data-image-path"),
	});
};

export default lottyAnim;



// WEBPACK FOOTER //
// ./scripts/modules/lottyAnim.js